import { createContext, useContext, useReducer } from "react";

const AddMovieContext = createContext();

export const useAddMovie = () => useContext(AddMovieContext);

const initialState = {
  title: "",
  description: "",
  category: "",
  language: "",
  country: "",
  releaseYear: "",
  movieFile: null,
  trailerFile: null,
  trailerProgress: 0,
  trailerUploading: false,
  trailerUploaded: false,
  cast: [],
  director: "",
  crew: [],
  artworkLandscape: null,
  artworkPortrait: null,
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_FIELD":
      return { ...state, [action.field]: action.value };

    case "ADD_CAST":
      return { ...state, cast: [...state.cast, action.value] };
    case "REMOVE_CAST":
      return {
        ...state,
        cast: state.cast.filter((member) => member !== action.value),
      };

    case "ADD_CREW":
      return { ...state, crew: [...state.crew, action.value] };
    case "REMOVE_CREW":
      return {
        ...state,
        crew: state.crew.filter((member) => member !== action.value),
      };

    case "SET_TRAILER_FILE":
      return {
        ...state,
        trailerFile: action.value,
        trailerProgress: 0,
        trailerUploading: true,
        trailerUploaded: false,
      };

    case "UPDATE_TRAILER_PROGRESS":
      return {
        ...state,
        trailerProgress: action.value,
      };

    case "TRAILER_UPLOAD_SUCCESS":
      return {
        ...state,
        trailerUploading: false,
        trailerUploaded: true,
        trailerProgress: 100,
      };

    case "REMOVE_TRAILER_FILE":
      return {
        ...state,
        trailerFile: null,
        trailerProgress: 0,
        trailerUploading: false,
        trailerUploaded: false,
      };

    case "RESET":
      return initialState;

    default:
      return state;
  }
}

export function AddMovieProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AddMovieContext.Provider value={{ state, dispatch }}>
      {children}
    </AddMovieContext.Provider>
  );
}
